import { Directive, Output, EventEmitter, ElementRef, OnDestroy } from '@angular/core';

@Directive({
	selector: '[appOptimizeListener]',
})
export class OptimizeListenerDirective implements OnDestroy {
	private changes: MutationObserver;
	@Output()
	public changeEvent = new EventEmitter();
	constructor(private elementRef: ElementRef) {
		const changes = new MutationObserver((mutations: MutationRecord[]) => {
			mutations.forEach((mutation: MutationRecord) => {
				if (mutation.type === 'childList') {
					this.changeEvent.emit(true);
				}
			});
		});
		changes.observe(elementRef.nativeElement, {
			childList: true,
		});
	}

	ngOnDestroy(): void {
		if (this.changes) {
			this.changes.disconnect();
		}
	}
}
